<template>
        <div class="page-container clearfix" v-if="showbanner">
            <div class="detail-wrapper">
                <div class="details">
                    <div class="textcontent">                       
                        <div class="title-video">
                           {{item.items[0].name}}
                        </div>
                        <div class="des">
                            {{item.items[0].description}}
                        </div>
                        <div class="btn-cont">
                            <div class="watchnow" @click="playvideo(item.items[0])">Watch Now</div>
                        </div>
                    </div>
                </div>
                <div class="image"> 
                    <img :src="bgImg">
                </div>
            </div>
        </div>
</template>


<script>
    export default {
        name: 'HomeHeader',
         props: ['catid'],
        data(){
            return{
                bgImg:"https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
                item:[],
                showbanner:false

            }
        },
        beforeCreate(){
         this.$store.commit('setLoader', true);  
           this.$store.dispatch('getCatalougeById' , this.$store.state.globalconfigs.banner_id).then((res)=>{
             this.item = res._embedded;
              this.$store.commit('setLoader', false); 
              this.bgImg = res._embedded.items[0].thumbnail.large;
              this.showbanner = true;
          }).catch(err =>{
            this.nocontent = true
             this.$store.commit('setLoader', false);  
          } );
          
        },
        methods:{
            goToDetails(current){
                var dynamicRoute = '/details/'+current.id+'/'+this.item._id;
                this.$router.push(""+dynamicRoute).then(res => this.$router.go(0))

            },
            playvideo(current) {
			var dynamicRoute = "/viewvideo/" + current.id;
			this.$router.push("" + dynamicRoute);
		},
        }
    }
</script>

<style>
    .page-container {
        margin-bottom: -250vh;
        position: relative;
        width: 100%;
        height: auto;
        min-height: 80vh;
        padding-top: 70px;
    }
    .detail-wrapper{
        position: relative;
        height: 70vh;
        width: 100%;
    }
     .detail-wrapper .details{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 39%;
        box-shadow: 20px 0px 30px 45px black;
        z-index: 10;
     }
     .detail-wrapper .image{
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 60%;
        box-shadow: inset -20px -20px 63px 20px rgb(0, 0, 0);
    }
    .image img{
        width: 100%;
        height: 100%;
        opacity: .7;
    }
    .textcontent{
        
        padding: 40px;
        padding-top: 50px;
        color: #FFF;
    }
    .textcontent .des{
        font-size: 1rem;
    }
    .textcontent .title-video{
        font-size: 2.5rem;
        margin-bottom: 20px;
        margin-top: 20px;


    }    
    .textcontent .title-catalouge{
        font-size: 2.5rem;
        margin-bottom: 20px;
        margin-top: 20px;


    }
    .textcontent .btn-cont{
        width: 50%;
        padding-top: 20px;
    }
    .textcontent .watchnow{
    padding: 10px;
    font-size: 1.2rem;
    border-radius: 3px;
    cursor: pointer;
    background: transparent;
    color: #fff;
    border:1px solid #fff;
    text-align: center;
    }
    @media only screen and (max-width: 600px) {
    .detail-wrapper{
        position: relative;
        height: 50vh;
        width: 100%;
    }
    .detail-wrapper .details {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    box-shadow: 1px 1px 17px 13px #000000c9;
    z-index: 10;
    background: #000000cf;
    border: none;
    }
    .page-container {
    position: relative;
    width: 100%;
    height: auto;
    min-height: 70vh;
    padding-top: 70px;
    }
    .detail-wrapper .image img{
        opacity: .9;
    }

    .detail-wrapper .image{
        width: 100%;
    }
    }
    .header__show-name h3 {
    width: 50%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    }
</style>

